import { Divider } from 'semantic-ui-react';

export default Divider;
